'use client'
import React, { useEffect, useState } from 'react'
import { Col, Row } from '../../row'

function ChartFilter({ allData, setNewData, typeWiseRun, runs, currentTeamId }: any) {
  // ************* CONSTANTS *************
  const types = ['1s', '2s', '3s', '4s', '6s']

  const [currentTypes, setCurrentTypes] = useState<any>(types)
  const [isAll, setIsAll] = useState(true)

  useEffect(() => {
    setCurrentTypes(types)
    setIsAll(true)
  }, [currentTeamId])

  // ************* FUNCTIONS *************

  // !FILTER DATA RUN WISE
  function handleShots(type: string) {
    if (type === 'All') {
      const newIsAll = !isAll
      setIsAll(newIsAll)
      setCurrentTypes(newIsAll ? types : [])
      setNewData(newIsAll ? allData : [])
    } else {
      const updatedTypes = currentTypes.includes(type)
        ? currentTypes.filter((t: string) => t !== type)
        : [...currentTypes, type]

      const newIsAll = updatedTypes.length === types.length
      setIsAll(newIsAll)
      setCurrentTypes(updatedTypes)
      setNewData(allData.filter((d: any) => updatedTypes.includes(d.type)))
    }
  }

  const countRuns: any = {
    '1s': 1,
    '2s': 2,
    '3s': 3,
    '4s': 4,
    '6s': 6
  }

  return (
    <div>
      <Row className="flex justify-center md:gap-4 px-4 mb-4">
        <Col
          md={2}
          xs={4}
          onClick={() => handleShots('All')}
          className={`flex items-center justify-start h-6 gap-1 md:gap-2 cursor-pointer py-4 px-1 text-white rounded-lg`}
        >
          <span
            className={`${isAll ? `bg-t-origin` : ''} md:h-4 md:w-4 h-3 w-3 block rounded-full border-2 border-t-origin `}
          />
          <p
            className={`text-[11px] line-clamp-2 text-t-origin whitespace-nowrap text-start md:text-lg `}
          >
            All:-{runs?.total} runs
          </p>
        </Col>
        {types?.map((t: string, i: number) => {
          return (
            <Col
              md={2}
              xs={4}
              key={i}
              onClick={() => handleShots(t)}
              className={` cursor-pointer flex items-center px-2 py-1 h-8  rounded-full gap-1 md:gap-2 border border-f-${i + 1}`}
            >
              <span
                className={`${
                  currentTypes?.includes(t) ? `bg-f-${i + 1}` : ''
                } md:h-4 md:w-4 h-3 w-3 block rounded-full border border-textDselected`}
              />
              <p className={`text-f-${i + 1} text-xs line-clamp-1 md:text-base font-bold`}>
                {t}:- {typeWiseRun[t] * countRuns[t]} runs
              </p>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default ChartFilter
